import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { SewerTinderComponent } from './sewer-tinder/pages/sewer-tinder/sewer-tinder.component';
import { UploadDashboardComponent } from './upload/pages/upload-dashboard/upload-dashboard.component';
// import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { DashboardAnnoncementComponent } from './_admin/announcements/pages/dashboard-annoncement/dashboard-annoncement.component';
import { DashboardEventComponent } from './_admin/events/pages/dashboard-event/dashboard-event.component';
import { ManageAccessPageComponent } from './_admin/manage-access/pages/manage-access-page/manage-access-page.component';
import { UserManagementPageComponent } from './_admin/user-managment/pages/user-managment-page/user-management-page.component';
import { VideoQueueDashboardComponent } from './_admin/video-queue-dashboard/video-queue-dashboard.component';
import { adminGuard } from './_helpers/Admin.guard';
import { partnerAdminGuard } from './_helpers/PartnerAdmin.guard';
import { adoptionPipeInspectionGuard } from './_helpers/AdoptionPipeInspection.guard';
import { AuthGuard } from './_helpers/auth.guard';
import { BuildingRiskUserGuard } from './_helpers/BuildingRiskUser.guard';
import { dataCheckGuard } from './_helpers/DataCheck.guard';
import { dataExportGuard } from './_helpers/DataExport.guard';
import { engineerToolGuard } from './_helpers/EngineerTool.guard';
import { externalTicketGuard } from './_helpers/ExternalTicket.guard';
import { I32Guard } from './_helpers/I32.guard';
import { manholeInspectionGuard } from './_helpers/manhole-inpection.guard';
import { MapsGuard } from './_helpers/Maps.guard';
import { MerckTenantGuard } from './_helpers/MerckTenant.guard';
import { NivusGuard } from './_helpers/Nivus.guard';
import { OtpLoginGuard } from './_helpers/OtpLogin.guard';
import { OtpUploadGuard } from './_helpers/OtpUpload.guard';
import { pipeInspectionGuard } from './_helpers/PipeInspection.guard';
import { questionnaireGuard } from './_helpers/Questionnaire.guard';
import { SewerTinderGuard } from './_helpers/SewerTinder.guard';
import { SewerTinderDashboardGuard } from './_helpers/SewerTinderDashboardGuard';
import { SewerTinderV2Guard } from './_helpers/SewerTinderV2.guard';
import { SewerTinderV3Guard } from './_helpers/SewerTinderV3.guard';
import { SpecialSystemGuard } from './_helpers/SpecialSystem.guard';
import { SpecialSystemDocumentGuard } from './_helpers/SpecialSystemDocuments.guard';
import { TenantReadyGuard } from './_helpers/tenant-ready.guard';
import { TicketGuard } from './_helpers/Ticket.guard';
import { TokenGuard } from './_helpers/Token.guard';
import { tooltipUnsavedChangesGuard } from './_helpers/tooltip-unsaved-changes.guard';
import { UploadGuard } from './_helpers/Upload.guard';
import { DamageAssessmentComponent } from './damage-assessment/pages/damage-assessment/damage-assessment.component';
import { StatisticPageComponent } from './dashboard-statistic/pages/statistic-page/statistic-page.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { CompliteRegistrationComponent } from './pages/complite-registration/complite-registration.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { LoginOtpComponent } from './pages/login-otp/login-otp.component';
import { LogoutOtpComponent } from './pages/logout-otp/logout-otp.component';
import { OtpComponent } from './pages/otp/otp.component';
import { RecoveryPasswordComponent } from './pages/recovery-password/recovery-password.component';
import { SetPasswordComponent } from './pages/set-password/set-password.component';
import { RemediationMeasuresComponent } from './remediation-measures/pages/remediation-measures/remediation-measures.component';
import { TestProtocolPageComponent } from './test-protocol/pages/test-protocol-page/test-protocol-page.component';
import { TicketDashboardComponent } from './ticket-system/pages/tikcet-dashboard/ticket-dashboard.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivateChild: [tooltipUnsavedChangesGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
        pathMatch: 'full',
      },
      {
        path: 'admin',
        //component: AdminDashboardComponent,
        loadChildren: () => import('./_admin/admin.module').then((m) => m.AdminModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/video-queue',
        component: VideoQueueDashboardComponent,
        canActivate: [adminGuard],
      },
      { path: 'error', component: ErrorPageComponent },
      {
        path: 'wastewater/upload-content',
        component: UploadDashboardComponent,
        loadChildren: () => import('./upload/upload.module').then((m) => m.UploadModule),
        canActivate: [UploadGuard],
      },
      {
        path: 'wastewater/immediate-actions',
        component: SewerTinderComponent,
        loadChildren: () => import('./sewer-tinder/sewer-tinder.module').then((m) => m.SewerTinderModule),
        canActivate: [SewerTinderGuard],
      },
      {
        path: 'wastewater/damage-assessment',
        component: DamageAssessmentComponent,
        loadChildren: () =>
          import('./damage-assessment/damage-assessment.module').then((m) => m.DamageAssessmentModule),
        canActivate: [SewerTinderV3Guard],
      },
      {
        path: 'wastewater/remediation-measures',
        component: RemediationMeasuresComponent,
        loadChildren: () =>
          import('./remediation-measures/remediation-measures.module').then((m) => m.RemediationMeasuresModule),
        canActivate: [SewerTinderV2Guard],
      },
      {
        path: 'wastewater/dashboard',
        component: StatisticPageComponent,
        loadChildren: () =>
          import('./dashboard-statistic/dashboard-statistic.module').then((m) => m.DashboardStatisticModule),
        canActivate: [SewerTinderDashboardGuard],
      },
      {
        path: 'wastewater/data-check',
        component: TestProtocolPageComponent,
        loadChildren: () => import('./test-protocol/test-protocol.module').then((m) => m.TestProtocolModule),
        canActivate: [dataCheckGuard],
      },
      {
        path: 'wastewater/errors&ambiguities',
        component: TicketDashboardComponent,
        loadChildren: () => import('./ticket-system/ticket.module').then((m) => m.TicketModule),
        canActivate: [TicketGuard],
      },
      {
        path: 'wastewater/special-system',
        loadChildren: () => import('./special-system/special-system.module').then((m) => m.SpecialSystemModule),
        canActivate: [SpecialSystemGuard],
      },
      {
        path: 'baustellendokumentation',
        loadChildren: () =>
          import('./documentation-site/documentation-site.module').then((m) => m.DocumentationSiteModule),
        canActivate: [SpecialSystemDocumentGuard],
      },
      {
        path: 'wastewater/pipe-inspection',
        loadChildren: () => import('./pipe-inspection/pipe-inspection.module').then((m) => m.PipeInspectionModule),
        canActivate: [pipeInspectionGuard],
      },
      {
        path: 'wastewater/manhole-inspection',
        loadChildren: () =>
          import('./manhole-inspection/manhole-inspection.module').then((m) => m.ManholeInspectionModule),
        canActivate: [manholeInspectionGuard],
      },
      {
        path: 'wastewater/kanalyze',
        loadChildren: () => import('./kanalyse/kanalyse.module').then((m) => m.KanalyseModule),
        canActivate: [adoptionPipeInspectionGuard],
      },
      {
        path: 'wastewater/engineer-tool',
        loadChildren: () => import('./engineer-tool/engineer-tool.module').then((m) => m.EngineerToolModule),
        canActivate: [engineerToolGuard],
      },
      {
        path: 'external-tickets',
        loadChildren: () =>
          import('./inspection-tickets/inspection-tickets.module').then((m) => m.InspectionTicketsModule),
        canActivate: [externalTicketGuard],
      },
      {
        path: 'admin/errors&ambiguities',
        component: TicketDashboardComponent,
        loadChildren: () => import('./ticket-system/ticket.module').then((m) => m.TicketModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/invoice-reports',
        loadChildren: () =>
          import('./_admin/invoice-reports/invoice-reports.module').then((m) => m.InvoiceReportsModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/invoices',
        loadChildren: () =>
          import('./_admin/invoice-management/invoice-management.module').then((m) => m.InvoiceManagementModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/partners',
        loadChildren: () =>
          import('./_admin/partners/partners.module').then(
            (m) => m.PartnersModule
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'construction',
        loadChildren: () =>
          import('./construction-site/construction-site.module').then((m) => m.ConstructionSiteModule),
        canActivate: [AuthGuard, TenantReadyGuard],
      },
      {
        path: 'questionnaire-user',
        loadChildren: () =>
          import('./questionnaire-user/questionnaire-user.module').then((m) => m.QuestionnaireUserModule),
        canActivate: [questionnaireGuard],
      },
      {
        path: 'settings',
        loadChildren: () => import('./pages/settings/settings.module').then((m) => m.SettingsModule),
        canActivate: [AuthGuard, TenantReadyGuard],
      },
      {
        path: 'admin/settings',
        loadChildren: () => import('./pages/settings/settings.module').then((m) => m.SettingsModule),
        canActivate: [AuthGuard, TenantReadyGuard],
      },
      {
        path: 'maps',
        loadChildren: () => import('./maps/maps.module').then((m) => m.MapsModule),
        canActivate: [MapsGuard],
      },
      {
        path: 'transformation',
        loadChildren: () => import('./transformation/transformation.module').then((m) => m.TransformationModule),
        canActivate: [I32Guard],
      },
      {
        path: 'irap/sensoren',
        loadChildren: () => import('./sensoren/sensoren.module').then((m) => m.SensorenModule),
        canActivate: [NivusGuard],
      },
      {
        path: 'irap/building-risk',
        loadChildren: () => import('./building-risk/building-risk.module').then((m) => m.BuildingRiskModule),
        canActivate: [BuildingRiskUserGuard],
      },
      {
        path: 'irap/überflutung',
        loadComponent: () =>
          import('./map-layer/pages/map-layer-page/map-layer-page.component').then((m) => m.MapLayerPageComponent),
        canActivate: [MapsGuard, MerckTenantGuard],
        data: { title: 'Überflutung' },
      },
      {
        path: 'benutzermanagement/manage-access',
        component: ManageAccessPageComponent,
        loadChildren: () => import('./_admin/manage-access/manage-access.module').then((m) => m.ManageAccessModule),
        canActivate: [partnerAdminGuard],
      },
      {
        path: 'benutzermanagement/tenant-management',
        loadChildren: () =>
          import('./_admin/tenant-managment/tenant-management.module').then((m) => m.TenantManagementModule),
        canActivate: [partnerAdminGuard],
      },
      {
        path: 'benutzermanagement/partners',
        loadChildren: () =>
          import('./_admin/partners/partners.module').then((m) => m.PartnersModule),
        canActivate: [partnerAdminGuard],
      },
      {
        path: 'admin/maps',
        loadChildren: () => import('./maps/maps.module').then((m) => m.MapsModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/marketing/announcements',
        component: DashboardAnnoncementComponent,
        loadChildren: () => import('./_admin/announcements/announcements.module').then((m) => m.AnnouncementsModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/marketing/events',
        component: DashboardEventComponent,
        loadChildren: () => import('./_admin/events/event.module').then((m) => m.EventModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/upload-content',
        loadChildren: () => import('./upload/upload.module').then((m) => m.UploadModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/manage-access',
        component: ManageAccessPageComponent,
        loadChildren: () => import('./_admin/manage-access/manage-access.module').then((m) => m.ManageAccessModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/user-management',
        component: UserManagementPageComponent,
        loadChildren: () =>
          import('./_admin/user-managment/user-management.module').then((m) => m.UserManagementModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/tenant-management',
        loadChildren: () =>
          import('./_admin/tenant-managment/tenant-management.module').then((m) => m.TenantManagementModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/subscriptions',
        loadChildren: () => import('./_admin/subscriptions/subscriptions.module').then((m) => m.SubscriptionsModule),
        canActivate: [adminGuard],
      },
      {
        path: 'admin/apps/questionnaires',
        loadChildren: () => import('./_admin/questionnaires/questionnaires.module').then((m) => m.QuestionnairesModule),
        canActivate: [adminGuard],
      },
      {
        path: 'wastewater/data-export',
        loadChildren: () => import('./data-export/data-export.module').then((m) => m.DataExportModule),
        canActivate: [dataExportGuard],
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [TokenGuard],
  },
  // {
  //   path: 'signup',
  //   component: SignUpComponent,
  // },
  {
    path: 'recovery-password',
    component: RecoveryPasswordComponent,
  },
  { path: 'confirm-email', component: CompliteRegistrationComponent },
  { path: 'reset-password', component: ChangePasswordComponent },
  { path: 'set-password', component: SetPasswordComponent },
  {
    path: 'otp/login/:id',
    component: LoginOtpComponent,
    canActivate: [OtpLoginGuard],
  },
  {
    path: 'otp/upload',
    component: OtpComponent,
    canActivate: [OtpUploadGuard],
  },
  {
    path: 'otp/logout',
    component: LogoutOtpComponent,
    canActivate: [OtpLoginGuard],
  },
  { path: '**', redirectTo: '' },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      scrollPositionRestoration: 'enabled',
      canceledNavigationResolution: 'computed',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
